import LazyLoad from "vanilla-lazyload";
import Swiper from "swiper";

require("es6-promise").polyfill();
require("isomorphic-fetch");

export default function JournalSlider(container) {
  const sliderContainer = container;
  const slideList = container.querySelectorAll(".js-journal-slider-slide");
  const nextButtonElement = container.querySelector(".js-journal-slider-next");
  const journalContent = document.querySelector(".js-journal-content");
  const previousButtonElement = container.querySelector(
    ".js-journal-slider-prev"
  );
  let slider;
  const sliderOptions = {
    init: false,
    slideClass: "js-journal-slider-slide",
    wrapperClass: "js-journal-slider-wrapper",
    slidesPerView: "auto",
    spaceBetween: 40,
    navigation: {
      nextEl: nextButtonElement,
      prevEl: previousButtonElement
    },
    breakpoints: {
      // when window width is <= 1200px
      1200: {
        spaceBetween: 20
      }
    },
    on: {
      init() {
        setTimeout(() => {
          initLazyLoad();
        }, 200);
      }
    }
  };

  initSlider();

  function initLazyLoad() {
    const lazyLoad1 = new LazyLoad({
      container,
      elements_selector: ".js-lazy"
    });

    const lazyLoad2 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-bg",
      to_webp: true
    });

    const lazyLoad3 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-webp",
      to_webp: true
    });

    lazyLoad1.loadAll();
    lazyLoad2.loadAll();
    lazyLoad3.loadAll();
  }

  function initSlider() {
    slider = new Swiper(sliderContainer, sliderOptions);
    slider.init();
  }

  for (let i = 0, len = slideList.length; i < len; i++) {
    const slideJournal = slideList[i];

    slideJournal.addEventListener("click", activeSlideJournal);
  }

  function activeSlideJournal(e) {
    const slide = this;
    // console.log("target", e.target);
    if (e.target.closest(".journal-slide__overlay")) {
      return;
    }

    const dataParam = slide.getAttribute("data-parametr");
    const url = slide.getAttribute("data-url");

    const params = `id-slider=${dataParam}`;
    // console.log("slide", slide);

    const data = new FormData();
    data.append("json", JSON.stringify(params));

    journalRequest(url, data);

    if (!slide.classList.contains("is-active")) {
      slide.classList.add("is-active");
      // console.log("yes");
    }

    for (let j = 0, len = slideList.length; j < len; j++) {
      const slideJournal2 = slideList[j];

      if (slide !== slideJournal2) {
        if (slideJournal2.classList.contains("is-active")) {
          slideJournal2.classList.remove("is-active");
          // console.log("no");
        }
      }
    }
  }

  function journalRequest(urlContent, dataContent) {
    fetch(urlContent, {
      method: "POST",
      body: dataContent,
      credentials: "same-origin"
    })
      .then(function requestSuccess(response) {
        if (response.ok) {
          return response.json();
        }

        throw new Error("Network response was not ok.");
      })
      .then(function requestResponse(jsonData) {
        handleResponse(jsonData);
      });
  }

  function handleResponse(content) {
    while (journalContent.firstChild) {
      journalContent.removeChild(journalContent.firstChild);
    }

    updateItemsBlock(content.items);
  }

  function updateItemsBlock(content) {
    journalContent.innerHTML = content;

    // eslint-disable-next-line no-new
    new LazyLoad({
      container: journalContent,
      elements_selector: ".js-lazy-img"
    });

    // eslint-disable-next-line no-new
    new LazyLoad({
      container: journalContent,
      elements_selector: ".js-lazy-img-webp",
      to_webp: true
    });
  }
}
